module.exports = __webpack_public_path__ + "password_70x70.50bf4201a7d86f72e5eb86a69d373298.png";